module.exports = __webpack_public_path__ + "assets/img/yqhy.0e2ae765.png";